/**
 * Genera un identificativo univoco in stile Base62.
 * * @param input - (Opzionale) Se fornito (es. executionId), genera un ID deterministico.
 * Se omesso, genera un ID casuale basato sul tempo corrente.
 * @returns Una stringa composta da 29 caratteri Base62 + un suffisso numerico.
 */

export function generateUID(input?: string): string {
    const CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    const PAYLOAD_LENGTH = 29;

    // --- Logica Deterministica (Hashing FNV-1a) ---
    const getHash = (str: string) => {
        let hash = 2166136261;
        for (let i = 0; i < str.length; i++) {
            hash ^= str.charCodeAt(i);
            hash = Math.imul(hash, 16777619);
        }
        return Math.abs(hash);
    };

    // --- Logica Casuale (Originale buildGUID) ---
    const getRandomIndex = () => {
        let r;
        do {
            r = Math.floor(Math.random() * (16 * 62));
        } while (r > 61);
        return r;
    };

    let uid = '';
    let currentHash = input ? getHash(input) : 0;

    for (let i = 0; i < PAYLOAD_LENGTH; i++) {
        if (input) {
            // Generazione deterministica basata sull'input
            currentHash = Math.imul(currentHash ^ i, 16777619);
            uid += CHARSET.charAt(Math.abs(currentHash) % 62);
        } else {
            // Generazione casuale originale
            uid += CHARSET.charAt(getRandomIndex());
        }
    }

    // Aggiunta del suffisso numerico
    if (input) {
        // Suffisso derivato dall'input (rimane costante per lo stesso input)
        const deterministicSuffix = Math.abs(Math.imul(currentHash, 16777619)) % 10000000000;
        uid += deterministicSuffix.toString().padStart(10, '0');
    } else {
        // Suffisso basato sul tempo reale (comportamento originale)
        uid += Math.floor(new Date().getTime() / 1000);
    }

    return uid;
}